import { Button } from "../ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pages, total, onPage, testid }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-5 py-3 border-t border-white/[0.06]" data-testid={testid}>
      <span className="text-xs text-slate-500 font-mono">{total} registro(s) — página {page}/{pages}</span>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)}
          data-testid={`${testid}-prev`} className="h-8 border-slate-700 text-slate-300 hover:bg-slate-800">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)}
          data-testid={`${testid}-next`} className="h-8 border-slate-700 text-slate-300 hover:bg-slate-800">
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
